module.exports = __webpack_public_path__ + "static/media/drawer-button-close.0420ac16.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drawer-button-close.svg
// module id = 541
// module chunks = 1